import React from "react";

export const ProducerSummaryTitle = (props: any) => {
  const { record } = props;
  if (record === undefined) {
    return <span {...props}>売り手情報</span>;
  }

  return <span {...props}>{`売り手情報 ${record["name"]}`}</span>;
};
